import React from 'react';
import styled from 'styled-components';
import { useTransition, animated } from 'react-spring';

import { noPrint, Theme } from 'baukasten';

import { useNavbarCollapse } from 'features/navbar/NavbarCollapseContext';
import { NAVBAR_TRANSITION_DURATION } from 'features/navbar/constants';

import { ToastNotification } from './ToastNotification';
import { useToastContext } from './ToastContext';

const useToastDisplay = () => {
  const { toasts, clearToast } = useToastContext();
  return { toasts, clearToast };
};

const FloatingOverlay = styled.div<{ leftOffset: number }>`
  position: fixed;
  bottom: ${Theme.getBaseUnit(5)};
  // navbar width + padding
  left: ${({ leftOffset }) =>
    `calc(${leftOffset}px + ${Theme.getBaseUnit(5)})`};
  z-index: 500;
  // smooth slide when sidebar toggles
  transition: left ${NAVBAR_TRANSITION_DURATION} ease;
  ${noPrint}
`;

const ToastList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Theme.getBaseUnit(3)};
`;

export const ToastDisplay = () => {
  const { actualNavbarWidth } = useNavbarCollapse();
  const { toasts, clearToast } = useToastDisplay();

  const transitions = useTransition(toasts, {
    keys: toast => toast.key,
    from: { opacity: 0, maxHeight: 0, transform: 'translateY(100%)' },
    enter: { opacity: 1, maxHeight: 500, transform: 'translateY(0%)' },
    leave: { opacity: 0, maxHeight: 0, transform: 'translateY(100%)' },
  });

  return (
    <FloatingOverlay leftOffset={actualNavbarWidth}>
      <ToastList role="status" aria-live="polite">
        {transitions((style, toast) => (
          <animated.div style={style}>
            <ToastNotification
              toast={toast}
              key={toast.key}
              clear={() => clearToast(toast.key)}
            />
          </animated.div>
        ))}
      </ToastList>
    </FloatingOverlay>
  );
};
